import React from 'react';

import { Tooltip } from '@mui/material';

import useStyles from './styles';

interface Props {
    icon: React.ReactNode;
    link: string;
    tooltip?: React.ReactNode;
    className?: string;
}

const SocialButton: React.FC<Props> = ({ icon, link, tooltip, className }) => {
    const { classes, cx } = useStyles();
    return (
        <Tooltip title={tooltip || null} placement="top">
            <a href={link} rel="noopener noreferrer nofollow" className={cx(classes.root, className)} target="_blank">
                {icon}
            </a>
        </Tooltip>
    );
};

export default SocialButton;
